import { GENDER } from '@vindr/services/constants/common.constant';
import { getDateFormatted } from '@vindr/utils/helpers/common.helper';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { isEqual } from 'lodash';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const PatientInformation = ({
  name,
  id,
  birthDate,
  sex,
}: {
  name: string;
  id: string;
  birthDate: string;
  sex: GENDER;
}) => {
  const { t } = useTranslation('Vindoc');

  const patientInfo = [
    {
      label: t('Patient Name'),
      value: name || '',
    },
    {
      label: t('Patient ID'),
      value: id || '',
    },
    {
      label: t('Birthday'),
      value: birthDate ? dayjs(birthDate).format(getDateFormatted()) : '',
    },
    {
      label: t('Gender'),
      value: t(GENDER[sex]) || '',
    },
  ];

  return (
    <div>
      <Title level={4} className="mb-0 pb-3 pt-0">
        {t('Patient Information')}
      </Title>

      <div className="grid grid-cols-1 sm:grid-cols-2">
        {patientInfo.map((item, index) => (
          <div key={index}>
            <div className="flex flex-wrap space-x-1">
              <p className="m-0 basis-24">{item.label}:</p>
              <p className="m-0 flex-1">{item.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(PatientInformation, (prev, next) => isEqual(prev, next));
